export const GQL_ENDPOINT = 'https://us-west-2.cdn.hygraph.com/content/cmdm41n3u0d2f06ka32segzo2/master'